'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidPhoneNumber;

var _parsePhoneNumber = require('./parse-phone-number');

var _parsePhoneNumber2 = _interopRequireDefault(_parsePhoneNumber);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Validate that the phone number looks to be valid in the specified country.
 * @param {string} number Phone number to validate as valid, based on the country(s)
 *        in which it should reside.
 * @param {string|array} countryCode A single or list of country codes against which
 *        the number should be validated.
 */


function isValidPhoneNumber(number, countryCode) {
  if (typeof number !== 'string') return false;
  var parsedNumber = (0, _parsePhoneNumber2.default)(number, countryCode);
  return parsedNumber && parsedNumber.isValid();
} // isValidPhoneNumber()